

import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  WeaponLimitation,
  WeaponMasteryMasterFeature,
  WeaponMasteryProperty,
} from "@dndModels";

export class CharacterWeaponMastery extends CharacterFeatureSource {
  // The Weapon Mastery Property to apply
  source: WeaponMasteryProperty | null = null; 
  // The weapons to which we apply the property.
  // It's populated by WMFs and WMMFs. 
  // We can do a single weapon_limit for all of them from WMFs, but each WMMF would need its own limit.
  // If no WMFs for it then don't do one for it.
  // Sometimes it's empty. That does NOT mean apply to everything. 
  // It means it's only applied to specific weapons or abilities which have features as 
  // part of them which say to apply them.
  weapon_limits: WeaponLimitation[] = []; 
  cf_ids: string[] = [];
  
  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.weapon_limits = obj.weapon_limits ? obj.weapon_limits.map((o: any) => new WeaponLimitation(o)) : [];
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      weapon_limits: this.weapon_limits.map(o => o.toDBObj())
    };
  }

  clone(drop_ids = false): CharacterWeaponMastery {
    const clone = new CharacterWeaponMastery();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterWeaponMastery, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.weapon_limits = copyMe.weapon_limits.map(o => o.clone());
    this.cf_ids = [...copyMe.cf_ids];
  }
}

export class CharacterWeaponMasteryMaster {
  cwms: CharacterWeaponMastery[] = [];
  wm_ff: WeaponMasteryMasterFeature | null = null;
  
  constructor(obj?: any) {
    if (obj) {
    }
  }

  get weapon_limit() {
    if (this.wm_ff) {
      return this.wm_ff.weapon_limit;
    }
    return new WeaponLimitation();
  }

  toDBObj(): any {
    // const feature_source_obj = super.toDBObj();
    return {
      // ...feature_source_obj,
    };
  }

  clone(drop_ids = false): CharacterWeaponMasteryMaster {
    const clone = new CharacterWeaponMasteryMaster();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterWeaponMasteryMaster, drop_ids = false): void {
    // super.copy(copyMe, drop_ids);
    this.cwms = [...copyMe.cwms];
    this.wm_ff = copyMe.wm_ff;
  }
}
